module.exports = __webpack_public_path__ + "img/4.ecc9121c.jpeg";